import styled from "styled-components";
import ThemedModal from "./Modal/ThemedModal";
import background from "../assets/login/login-background.png";

const LoginModal = styled(ThemedModal)`
  .modal-content {
    min-width: 500px;
    background: transparent;
    border: 0;

    & > div {
      background: transparent !important;
    }
  }
  background: url(${background}) no-repeat center center;
  background-size: cover;
`;

export default LoginModal;
